import { useMutation } from "@tanstack/react-query";
import { api } from "../client";

export function useLogout() {
  return useMutation({
    mutationFn: async () => {
      const res = await api.logoutApi.apiLogoutPost({});
      return res.data;
    },
    meta: {
      skipGlobalError: false,
    },
  });
}
